define('collections/commons/province',[
    'jquery',
    'underscore',
    'backbone',
    // models
    'models/commons/province',
    // datafiles
    'text!assets/datafiles/provinces.json'
], function($, _, Backbone, MProvince, ProvincesData) {

    var data = $.parseJSON(ProvincesData);

    var CProvince = Backbone.Collection.extend({
        url: 'assets/datafiles/provinces.json',
        model: MProvince,
        initialize: function(models, opt) {
            // models = ProvincesData;
            this.set(data, { silent: true });
        },
    });

    return CProvince;

});

